module.exports = __webpack_public_path__ + "img/retrospect-process-1-mobile.986180f6.jpg";